__turbopack_context__.v({
  "header": "iCIKZa_header",
  "header--nav-open": "iCIKZa_header--nav-open",
  "header__wrapper": "iCIKZa_header__wrapper",
});
